import {createAction} from "@reduxjs/toolkit";

import {
  FETCH,
  DONE,
  FAIL,
  LESSON,
  VIEW,
  FILTER,
  SELECT,
  GET,
  PERIOD,
  RESET,
  ADD,
  FORM,
  POST,
  PLAN,
  ONE,
  DELETE,
  INNER,
  LIST,
  EDIT,
  CTP,
  TEST,
  ANSWER,
  DATA,
  CONTENT, COPY, RESULT, TASK, SET, MATERIAL, CURRENT, BEGIN, FINISH, LIBRARY, IMPORT, END, STUDENT, EXAM,
} from "../../constants";

export const getOneCtpAction = createAction<any>(GET + CTP + VIEW + FETCH);
export const getOneCtpActionDone = createAction<any>(GET + CTP + VIEW + FETCH + DONE);
export const getOneCtpActionFail = createAction<undefined>(GET + CTP + VIEW + FETCH + FAIL);

export const getPlanListAction = createAction<undefined>(GET + PLAN + LIST + FETCH);
export const getPlanListActionDone = createAction<any>(GET + PLAN + LIST + FETCH + DONE);
export const getPlanListActionFail = createAction<undefined>(GET + PLAN + LIST + FETCH + FAIL);

export const getPlansCurrentCtpListAction = createAction<any>(GET + PLAN + CURRENT + CTP + LIST + FETCH);
export const getPlansCurrentCtpListActionDone = createAction<any>(GET + PLAN + CURRENT + CTP + LIST + FETCH + DONE);
export const getPlansCurrentCtpListActionFail = createAction<any>(GET + PLAN + CURRENT + CTP + LIST + FETCH + FAIL);

export const getPlansCurrentFilterAction = createAction<any>(GET + PLAN + CURRENT + FILTER + FETCH);
export const getPlansCurrentFilterActionDone = createAction<any>(GET + PLAN + CURRENT + FILTER + FETCH + DONE);
export const getPlansCurrentFilterActionFail = createAction<undefined>(GET + PLAN + CURRENT + FILTER + FETCH + FAIL);


export const getCurrentPlanByCtpAction = createAction<any>(GET + CURRENT + PLAN + CTP + FETCH);
export const getCurrentPlanByCtpActionDone = createAction<any>(GET + CURRENT + PLAN + CTP + FETCH + DONE);
export const getCurrentPlanByCtpActionFail = createAction<undefined>(GET + CURRENT + PLAN + CTP + FETCH + FAIL);

export const getLessonAction = createAction<any>(LESSON + VIEW + FETCH);
export const getLessonActionDone = createAction<any>(LESSON + VIEW + FETCH + DONE);
export const getLessonActionFail = createAction<undefined>(LESSON + VIEW + FETCH + FAIL);

export const getOneLessonAction = createAction<any>(LESSON + VIEW + ONE + FETCH);
export const getOneLessonActionDone = createAction<any>(LESSON + VIEW + ONE + FETCH + DONE);
export const getOneLessonActionFail = createAction<undefined>(LESSON + VIEW + ONE + FETCH + FAIL);

export const addLessonAction = createAction<undefined>(LESSON + ADD + FETCH);
export const addLessonActionDone = createAction<any>(LESSON + ADD + FETCH + DONE);
export const addLessonActionFail = createAction<undefined>(LESSON + ADD + FETCH + FAIL);

export const editLessonAction = createAction<undefined>(LESSON + EDIT + FETCH);
export const editLessonActionDone = createAction<any>(LESSON + EDIT + FETCH + DONE);
export const editLessonActionFail = createAction<undefined>(LESSON + EDIT + FETCH + FAIL);

export const addOneLessonAction = createAction<undefined>(LESSON + ONE + ADD + FETCH);
export const addOneLessonActionDone = createAction<any>(LESSON + ONE + ADD + FETCH + DONE);
export const addOneLessonActionFail = createAction<undefined>(LESSON + ONE + ADD + FETCH + FAIL);

export const deleteOneLessonAction = createAction<any>(LESSON + DELETE + FETCH);
export const deleteOneLessonActionDone = createAction<any>(LESSON + DELETE + FETCH + DONE);
export const deleteOneLessonActionFail = createAction<undefined>(LESSON + DELETE + FETCH + FAIL);

export const addQuestionAnswerAction = createAction<any>(ADD + TEST + ANSWER + FETCH);
export const addQuestionAnswerActionDone = createAction<undefined>(ADD + TEST + ANSWER + FETCH + DONE);
export const addQuestionAnswerActionFail = createAction<undefined>(ADD + TEST + ANSWER + FETCH + FAIL);

export const getQuestionAnswerAction = createAction<any>(GET + TEST + ANSWER + FETCH);
export const getQuestionAnswerActionDone = createAction<undefined>(GET + TEST + ANSWER + FETCH + DONE);
export const getQuestionAnswerActionFail = createAction<undefined>(GET + TEST + ANSWER + FETCH + FAIL);

export const updateTabInnerContentAction = createAction<any>(EDIT + INNER + CONTENT + FETCH);
export const updateTabInnerContentActionDone = createAction<undefined>(EDIT + INNER + CONTENT + FETCH + DONE);
export const updateTabInnerContentActionFail = createAction<undefined>(EDIT + INNER + CONTENT + FETCH + FAIL);

export const deleteTabInnerContentAction = createAction<any>(DELETE + INNER + CONTENT + FETCH);
export const deleteTabInnerContentActionDone = createAction<undefined>(DELETE + INNER + CONTENT + FETCH + DONE);
export const deleteTabInnerContentActionFail = createAction<undefined>(DELETE + INNER + CONTENT + FETCH + FAIL);

export const copyPlanAction = createAction<any>(COPY + PLAN + FETCH);
export const copyPlanActionDone = createAction<undefined>(COPY + PLAN + FETCH + DONE);
export const copyPlanActionFail = createAction<undefined>(COPY + PLAN + FETCH + FAIL);

export const testResultAction = createAction<any>(TEST + RESULT + FETCH);
export const testResultActionDone = createAction<undefined>(TEST + RESULT + FETCH + DONE);
export const testResultActionFail = createAction<undefined>(TEST + RESULT + FETCH + FAIL);

export const taskResultSendAction = createAction<any>(TASK + RESULT + SET + FETCH);
export const taskResultSendActionDone = createAction<undefined>(TASK + RESULT + SET + FETCH + DONE);
export const taskResultSendActionFail = createAction<undefined>(TASK + RESULT + SET + FETCH + FAIL);

export const materialResultSendAction = createAction<any>(MATERIAL + RESULT + SET + FETCH);
export const materialResultSendActionDone = createAction<undefined>(MATERIAL + RESULT + SET + FETCH + DONE);
export const materialResultSendActionFail = createAction<undefined>(MATERIAL + RESULT + SET + FETCH + FAIL);

export const testsImportAction = createAction<any>(TEST + IMPORT + FETCH);
export const testsImportActionDone = createAction<undefined>(TEST + IMPORT + FETCH + DONE);
export const testsImportActionFail = createAction<undefined>(TEST + IMPORT + FETCH + FAIL);

export const testBegin = createAction<any>(TEST + BEGIN + FETCH);
export const testBeginDone = createAction<any>(TEST + BEGIN + FETCH + DONE);
export const testBeginFail = createAction<undefined>(TEST + BEGIN + FETCH + FAIL);

export const testImportFromLibrary = createAction<any>(TEST + IMPORT + LIBRARY + FETCH);
export const testImportFromLibraryDone = createAction<undefined>(TEST + IMPORT + LIBRARY + FETCH + DONE);
export const testImportFromLibraryFail = createAction<undefined>(TEST + IMPORT + LIBRARY + FETCH + FAIL);

export const testEnd = createAction<any>(TEST + END + FETCH);
export const testEndDone = createAction<undefined>(TEST + END + FETCH + DONE);
export const testEndFail = createAction<undefined>(TEST + END + FETCH + FAIL);

export const setStudentListAction = createAction<any>(SET + STUDENT + LIST + FETCH);
export const setStudentListActionDone = createAction<undefined>(SET + STUDENT + LIST + FETCH + DONE);
export const setStudentListActionFail = createAction<undefined>(SET + STUDENT + LIST + FETCH + FAIL);

export const getOneTaskAction = createAction<any>(GET + TASK + ONE + FETCH);
export const getOneTaskActionDone = createAction<any>(GET + TASK + ONE + FETCH + DONE);
export const getOneTaskActionFail = createAction<undefined>(GET + TASK + ONE + FETCH + FAIL);

export const resetPlan = createAction<undefined>(RESET + PLAN);

export const getExamStatementAction = createAction<any>(GET + EXAM + ONE + FETCH);
export const getExamStatementActionDone = createAction<any>(GET + EXAM + ONE + FETCH + DONE);
export const getExamStatementActionFail = createAction<undefined>(GET + EXAM + ONE + FETCH + FAIL);